<template lang="html">
  <div class="section">
    <div class="Slide">
      <section>
        <header>
          <p><img src="../assets/images/top/img_idea-header.svg" alt="理念"></p>
          <h2>平成２２年３月に、児童の心身ともに<br class="visible-sm">健やかな育成に寄与する<br class="hidden-sm">事を目的に、<br class="visible-sm">地域とも連携し設立いたしました。</h2>
        </header>
        <p><img class="alignLeft" src="../assets/images/top/img_idea.png" alt="">私たち一般社団法人おやこハグネットは平成２２年３月に、児童の心身ともに健やかな育成に寄与する事を目的に、地域とも連携し設立いたしました。<br>
        <br>
        放課後児童クラブでは、“就労中の保護者が子どもさんを、安心して預けられる場所作り”“子どもたちが、安全に安定して過ごせる居心地の良い空間づくり”を目的とし運営しています。<br>
        また人と人のコミュニケーションを大切にし、保護者、学校、地域の方々と連携して子どもたちの健全な育成を行っております。<br>
        <br>
        児童家庭支援事業では、山代温泉まちづくり推進協議会と連携し、児童の学習支援をはじめ、今現在地域にある子ども達や子育て家庭が抱える問題を、様々な機関の方々と話し合い、ニーズに対応した支援が出来るよう取り組んでいます。</p>
        <p class="sign"><small>一般社団法人おやこハグネット</small></p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdeaSlide',
};
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/_mixin.scss';
.Scene001 {
  opacity: 0;
}
.Slide {
  padding: 4rem 0;
  background-color: #ffc3c3;
  @include media( md ) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    padding: 0;
  }
}
section {
  max-width: 1000px;
}
header {
  margin-bottom: 1.0rem;
  text-align: center;
  p {
    margin: 0;
    padding: 0;
    line-height: 0;
    img {
      text-align: center;
    }
  }
  @include media( md ) {
    display: flex;
    align-items: center;
    margin-bottom: 6.0rem;
    text-align: left;
    p {
      img {
        margin: 0 3.5rem 0 0;
      }
    }
  }
}
h2 {
  font-size: 1.7rem;
  line-height: 1.35;
  @include media( md ) {
    font-size: 2.9rem;
  }
}
p {
  padding: 0 15px;
  font-size: 1.2rem;
  line-height: 1.5;
  &.sign {
    text-align: right;
  }
  .alignLeft {
    display: block;
    margin: 3rem auto;
  }
  @include media( sm ) {
    font-size: 1.5rem;
    line-height: 2;
    &.sign {
      font-size: 1.7rem;
    }
  }
  @include media( md ) {
    .alignLeft {
      display: inline;
      margin: {
        top: 0;
        right: 3.5em;
        bottom: 2em;
      }
      float: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// IdeaSlide.vue?1c510a4e